/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_Team_Feat3Inputs */

const en_mk_price_team_feat3 = /** @type {(inputs: Mk_Price_Team_Feat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit log, inbound WhatsApp`)
};

const id_mk_price_team_feat3 = /** @type {(inputs: Mk_Price_Team_Feat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit log, integrasi WhatsApp masuk`)
};

/**
* | output |
* | --- |
* | "Audit log, inbound WhatsApp" |
*
* @param {Mk_Price_Team_Feat3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_team_feat3 = /** @type {((inputs?: Mk_Price_Team_Feat3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_Team_Feat3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_team_feat3(inputs)
	return en_mk_price_team_feat3(inputs)
});